module.exports = __webpack_public_path__ + "static/media/idash-screenshot.abb3c0a9.png";